<template>
    <div>
        <div id="qrcode" class="login"></div>
    </div>
</template>
<script>
import '../../static/wxLogin'
const IPCONFIG = process.env.VUE_APP_URL
export default {
    data(){
        return {

        }
    },
    methods:{
        handleLogin(){
           var obj =  new WxLogin({
              self_redirect:false,
              id:'qrcode',
            //   appid:'wxe6ea996dfd17db91',
              appid:'wxfac3db38e5e58620',
              scope:'snsapi_login',
              redirect_uri: IPCONFIG.indexOf('dev') != -1 ? encodeURIComponent('https://ts.eyaoban.com/zeta_dev_frontend/#/') : encodeURIComponent('https://ts.eyaoban.com/zeta_frontend/#/'),
            //   redirect_uri: encodeURIComponent('https://ts.eyaoban.com/zeta_frontend/#/'),
              state:'pclogin',
              style:'black',
              href:'',
            })
        }
    },
    mounted(){
        this.handleLogin();
    }
}
</script>
<style scoped>
    .login {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10%;
    }
</style>


// WEBPACK FOOTER //
// src/components/pcLogin.vue